<template>
  <div class="py-5">
    <b-form novalidate id="admin-oversattningar" @submit="onSubmit" @reset="onReset">
      <b-overlay :show="loading" rounded opacity="0.8" spinner-small spinner-variant="primary" @hidden="onOverlayHidden">
        <b-container>
          <div>
            <b-card no-body v-if="content">
              <b-card-text>
                <table class="table">
                  <thead class="table-secondary">
                    <tr>
                      <!-- <th scope="col"></th> -->
                      <th scope="col">
                        <div class="d-flex align-items-center justify-content-start">
                          <country-flag country="se" size="small" class="m-0 scaled-flag" />
                          <span>{{ $t("text.admin.sv") }}</span>
                        </div>
                      </th>
                      <th class="col">
                        <div class="d-flex align-items-center justify-content-start">
                          <country-flag country="no" size="small" class="m-0 scaled-flag" />
                          <span>{{ $t("text.admin.no") }}</span>
                        </div>
                      </th>
                      <th class="col">
                        <div class="d-flex align-items-center justify-content-start">
                          <country-flag country="dk" size="small" class="m-0 scaled-flag" />
                          <span>{{ $t("text.admin.dk") }}</span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-secondary">
                    <tr v-for="row in content" :key="row.machineName">
                      <!-- <th scope="row">{{ row.machineName }}</th> -->
                      <td class="col">
                        <b-form-textarea :readonly="isReadonly(1)" rows="6" v-model="row.text" placeholder=""></b-form-textarea>
                      </td>
                      <td class="col">
                        <b-form-textarea :readonly="isReadonly(2)" rows="6" v-model="row.translations.no.text" placeholder=""></b-form-textarea>
                      </td>
                      <td class="col">
                        <b-form-textarea :readonly="isReadonly(3)" rows="6" v-model="row.translations.dk.text" placeholder=""></b-form-textarea>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-card-text>
            </b-card>
          </div>
          <hr class="my-5" />
          <b-row class="mt-4">
            <b-col>
              <b-button size="lg" type="button" :to="{ name: 'adm-dashboard' }" variant="outline-primary"><b-icon icon="chevron-left"></b-icon> {{ $t("text.admin.ga-till-lista") }}</b-button>
            </b-col>
            <b-col align="right">
              <b-button size="lg" type="submit" variant="primary">{{ $t("text.admin.spara") }}</b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
  import ApiServiceAdmin from "@/services/ApiServiceAdmin";
  import AdminEditMixin from "@/mixins/AdminEditMixin";
  import AdminMessagesMixin from "@/mixins/AdminMessagesMixin";
  import _ from "lodash";
  export default {
    name: "AdminOversattningar",
    mixins: [AdminEditMixin, AdminMessagesMixin],
    data() {
      return {
        content: [],
        form: {},
      };
    },
    methods: {
      onSubmit(event) {
        this.loading = true;
        event.preventDefault();
        
        this.content.forEach((row) => {
          ApiServiceAdmin.updateContentById(row._id, _.pick(row, ["machineName", "text", "translations"]))
            .then(() => {})
            .catch(this.handleError);
        });
        this.makeToast({ variant: "success", title: "Success", text: "Updated content" });
        this.loading = false;
      },
      async initFormData() {
        try {
          await ApiServiceAdmin.getContentData(this.id, []).then((response) => {
            console.log("response.data", response.data);
            this.content = response.data;
            // this.content = _.map(response.data, (c) => _.pick(c, ["machineName", "text", "translations"]));
            console.log("this.content", this.content);
          });
        } catch (error) {
          console.log(error);
        }
      },
      isReadonly(area_level) {
        const access_level = localStorage.getItem('access_level')

        if (access_level === "0") {
          return false;
        }

        if (area_level.toString() === access_level) {
          return false
        }

        return true;
      }
    },
    mounted() {
      this.initFormData();
    },
  };
</script>

<style lang="scss" scoped>
  .scaled-flag {
    transform: scale(0.6);
  }
  .product.card {
    min-height: 34px;
    &.active {
      border-width: 1px;
      border-right-width: 10px;
      &:after {
        width: 120px;
        right: -130px;
      }
    }
  }
  .table {
    table-layout: fixed;
    width: 100%;

    th,
    td {
      width: calc(100% / 3);
    }
  }
</style>
